/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-props-no-spreading */

import { useState, useCallback, useMemo } from "react";

import "./app.scss";

import {
  faArrowLeft,
  faCommentAlt,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useSpring, animated } from "react-spring";
import { ChatProvider } from "~/context/chat";
import { useChat } from "~/hooks/chat";

import ChatContact from "~/components/ChatContact";
import ChatInternal from "~/components/ChatInternal";
import { Button } from "~/components/Button";
import Chat from "~/components/Chat";

const App: React.FC = () => {
  const {
    company,
    isExternal,
    createChat,
    user,
    notifications,
    chat,
    setKeyData,
    title: _title,
  } = useChat();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [showOffChat, setShowOffChat] = useState<boolean>(false);
  const [showHelp, setShowHelp] = useState<boolean>(false);
  const [isChatOpen, setIsChatOpen] = useState<boolean>(true);

  const [fullMenuVisible, setFullMenuVisible] = useState(false);

  const toggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const expand = useSpring({
    maxHeight: fullMenuVisible ? `700px` : "0px",
  });

  const render = useMemo(() => {
    if (chat) {
      return <Chat setIsChatOpen={setIsChatOpen} setShowHelp={setShowHelp} />;
    }
    if (isExternal) {
      return (
        <animated.div style={expand}>
          <ChatContact
            showOffChat={showOffChat}
            setShowOffChat={setShowOffChat}
          />
        </animated.div>
      );
    }
    if (!isExternal) {
      return (
        <animated.div style={expand}>
          <ChatInternal
            showOffChat={showOffChat}
            showHelp={showHelp}
            setShowHelp={setShowHelp}
            setShowOffChat={setShowOffChat}
          />
        </animated.div>
      );
    }
  }, [
    createChat,
    isExternal,
    chat,
    user,
    company,
    notifications,
    showHelp,
    showOffChat,
  ]);

  const title = useMemo(() => {
    if (_title) {
      return _title;
    }
    if (!isExternal) {
      return "Atendimento";
    }
    if (isExternal) {
      return "Vendas Online";
    }
  }, [createChat, isExternal, chat, user, company, notifications, _title]);

  const hasNot = useMemo(() => {
    return notifications?.find(
      not => not.status === 0 && not.user_uuid === user?.uuid,
    );
  }, [notifications, user]);

  return (
    <>
      <div
        id="myDIV"
        className={`cloudez-chat-app ${isOpen ? "open" : "close"}`}
      >
        {isOpen ? (
          <>
            <header>
              <div>
                <>
                  {(chat && !isExternal) || showOffChat || showHelp ? (
                    <>
                      <FontAwesomeIcon
                        icon={faArrowLeft}
                        onClick={() => {
                          setKeyData("chat", null);
                          setShowOffChat(false);
                          setShowHelp(false);
                          setIsChatOpen(!isChatOpen);
                        }}
                      />
                      {title}
                    </>
                  ) : (
                    <>
                      {!isChatOpen && isExternal ? (
                        <>
                          <FontAwesomeIcon
                            icon={faArrowLeft}
                            onClick={() => {
                              setKeyData("chat", null);
                              setShowOffChat(false);
                              setShowHelp(false);
                              setIsChatOpen(!isChatOpen);
                            }}
                          />
                          {title}
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faCommentAlt} />
                          {title}
                        </>
                      )}
                    </>
                  )}
                </>
              </div>
              <FontAwesomeIcon
                icon={faMinus}
                onClick={() => {
                  toggleOpen();
                  setFullMenuVisible(false);
                  if (chat?.rating !== null && isExternal) {
                    setKeyData("chat", null);
                    setKeyData("createChat", true);
                  }
                }}
              />
            </header>
            {render}
          </>
        ) : (
          <>
            {hasNot && <span className="notification" />}
            <Button
              icon={faCommentAlt}
              onOpen={() => {
                toggleOpen();
                setFullMenuVisible(true);
              }}
              title={title}
            />
          </>
        )}
      </div>
    </>
  );
};

export default (props: any) => (
  <ChatProvider>
    <App {...props} />
  </ChatProvider>
);
